export default {
  cognito: {
    REGION: 'us-east-1',
    USER_POOL_ID: 'us-east-1_uViyQNDBp',
    USER_POOL_ARN: 'arn:aws:cognito-idp:us-east-1:360233388836:userpool/us-east-1_uViyQNDBp',
    APP_CLIENT_ID: '1sus1gi0r22qm28des1t15j1hv',
    IDENTITY_POOL_ID: 'us-east-1:a45d0986-72ba-4aa2-b887-5074268c618a'
  }
}